<template>
<div>
      <v-select
        v-model="newselectedValueOption"
        :reduce="(city_options) => city_options.code"
        :options="city_options"
        @search="fetchOptions"
        @input="selectedOption"
        :label="'name'"
        >
      </v-select>      
</div>
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import CommonServices from '../../services/common-services'
var debounce = require('debounce');

import axios from 'axios';

export default {
  name: 'search-select',
  props:['preSelect','labelName','remoteControl'],
  data() {
    return {
      city_options: [],
      newselectedValueOption:{},
      counter:0,
      urlAppend:CommonServices.base_url('bajajAPI/commonData/cities')
    };
  },
  components: {
    vSelect,
  },
  mounted(){
    if(this.preSelect){
      // this.newselectedValueOption = this.preSelectComputed
      this.newselectedValueOption = this.preSelect
    }
    this.urlAppend = CommonServices.base_url(this.remoteControl)
  },
    
  computed:{
    preSelectComputed:{
      get: function () {
        // return this.newselectedValueOption
      return this.preSelect
      },
      set: function (newValue) {
        // this.newselectedValue   = newValue
         const result = this.city_options.find(val => val.code === newValue);
        
        this.newselectedValueOption = result
        // this.preSelect = result;
        this.$emit('selectedData', result)
        
      }
    },
    // pavanCities:{
    //   get: function () {
    //     // return [this.preSelect]
    //     return [this.newselectedValueOption]
    //   },
    //   set: function (newValue) {
    //     // this.newselectedValue   = newValue
    //      const result = this.city_options.find(val => val.code === newValue);
        
    //     this.newselectedValueOption = result
        
    //   }      
    // }
  },
  methods: {
   
    fetchOptions(search, loading) {
      if (search.length) {
        loading(true);
        this.searchVal(search, loading,this.urlAppend, this);

      }
    },
    selectedOption(value) {
      this.preSelectComputed =value
      // console.log('value : ' + value);
      // console.log('computed catch : ==> '+this.newselectedValue)
      
      
      // this.selectedOptionArray = result
      // this.$emit('selectedOptionArray', result)
    //  const result = this.city_options.find(val => val.code === value);
        
    //     this.newselectedValueOption = result

    },
    searchVal: debounce((search, loading, url, vm) => {
      // var el = vm;
      // AJAX request
      
      axios
        .get(url, {
          params: {
            search: search,
          },
        })
        .then(function (response) {
          vm.city_options = response.data.cities;
          // vm.cityList = response.data.cities
        });
      loading(false);
    }, 350),
  },
 watch:{
   preSelect:function(newVal, oldVal){
    //  console.log('Prop changed: ', newVal, ' | was: ', oldVal)
     this.newselectedValueOption = this.preSelectComputed
   }
 },
};
</script>
<style scoped>
</style>

//https://vue-select.org/guide/values.html#transforming-selections
//https://makitweb.com/make-dropdown-with-search-box-with-vue-select-vue-js/
